import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import { useToast } from '../context/ToastContext';

const ToastAlert: React.FC = () => {
  const { toast, closeToast } = useToast();

  return (
    <Snackbar
      open={toast.open}
      autoHideDuration={3000}
      onClose={closeToast}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert onClose={closeToast} severity={toast.severity} sx={{ width: '100%' }}>
        {toast.message}
      </Alert>
    </Snackbar>
  );
};

export default ToastAlert;
